import { Box, Card, ColorSwatch, Group, Stack, Text } from "@mantine/core";
import { RoundedNumberFormat } from "../../../utils/RoundedNumberFormat";
import { ContentWithSkeleton } from "../../ContentWithSkeleton/ContentWithSkeleton";

interface TotalsSideBarProps {
  unit: string;
  totalsSeries: Array<{
    label: string | undefined;
    value: number | null | undefined;
    color: string | undefined;
  }>;
  mah?: number;
}

function TotalsSideBar({ unit, totalsSeries, mah }: TotalsSideBarProps) {
  const formattedUnit = unit.includes(" ") ? unit : ` ${unit}`;
  return (
    <Card
      aria-label="Summen"
      className="sidebar"
      mah={mah}
      miw={220}
      style={{ overflowY: mah ? "auto" : undefined }}
      withBorder
    >
      <Stack gap={"sm"}>
        {totalsSeries.map((series, index) => (
          <div key={series.label ?? index}>
            <Text c="dimmed" size="xs">
              {series.label ?? "Unbekannt"}
            </Text>
            <Box>
              <Group gap={"xs"}>
                <ColorSwatch
                  color={series.color ?? "gray"}
                  size="var(--mantine-font-size-xs)"
                />
                <ContentWithSkeleton isLoading={series.value === undefined}>
                  {series.value === null ? (
                    <Text c="dimmed">Keine Daten</Text>
                  ) : (
                    <RoundedNumberFormat
                      decimalScale={2}
                      displayType="text"
                      suffix={formattedUnit}
                      value={series.value}
                    />
                  )}
                </ContentWithSkeleton>
              </Group>
            </Box>
          </div>
        ))}
      </Stack>
    </Card>
  );
}

export { TotalsSideBar };
